var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTakeMeThere(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 948,
    height: 834,
    viewBox: "0 0 948 834",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Enabble Location"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M858.295 455.683C858.295 662.263 690.824 829.734 484.244 829.734C277.664 829.734 110.197 662.263 110.197 455.683C110.197 249.103 277.664 81.6328 484.244 81.6328C690.824 81.6328 858.295 249.103 858.295 455.683Z",
    stroke: "#E9EAEC",
    strokeWidth: 1.47406,
    strokeDasharray: "7.4 7.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M762.013 455.686C762.013 609.094 637.649 733.458 484.241 733.458C330.829 733.458 206.473 609.094 206.473 455.686C206.473 302.278 330.829 177.914 484.241 177.914C637.649 177.914 762.013 302.278 762.013 455.686Z",
    stroke: "#E9EAEC",
    strokeWidth: 1.47406,
    strokeDasharray: "7.44 7.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 5",
    d: "M39.5199 506.041L32.5752 505.828",
    stroke: "#D2D8DF",
    strokeWidth: 1.47406,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 7",
    d: "M34.5499 492.879L29.5693 497.532",
    stroke: "#D2D8DF",
    strokeWidth: 1.47406,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 9",
    d: "M21.5733 486.867L21.4688 493.657",
    stroke: "#D2D8DF",
    strokeWidth: 1.47406,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 11",
    d: "M8.18262 491.52L13.0191 496.471",
    stroke: "#D2D8DF",
    strokeWidth: 1.47406,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 13",
    d: "M2.25 504.129L9.19114 504.342",
    stroke: "#D2D8DF",
    strokeWidth: 1.47406,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 15",
    d: "M7.22461 517.301L12.2088 512.648",
    stroke: "#D2D8DF",
    strokeWidth: 1.47406,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 17",
    d: "M20.2061 523.317L20.3106 516.527",
    stroke: "#D2D8DF",
    strokeWidth: 1.47406,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 19",
    d: "M33.5943 518.655L28.7578 513.703",
    stroke: "#D2D8DF",
    strokeWidth: 1.47406,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 21",
    d: "M945.199 409.242L942.146 412.547",
    stroke: "#D2D8DF",
    strokeWidth: 1.47406,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 23",
    d: "M930.876 412.113L933.179 414.236",
    stroke: "#D2D8DF",
    strokeWidth: 1.47406,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 25",
    d: "M928.553 426.762L931.605 423.457",
    stroke: "#D2D8DF",
    strokeWidth: 1.47406,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 27",
    d: "M942.867 423.881L940.567 421.758",
    stroke: "#D2D8DF",
    strokeWidth: 1.47406,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 29",
    d: "M665.621 20.8232L658.236 20.625",
    stroke: "#D2D8DF",
    strokeWidth: 1.47406,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 31",
    d: "M646.515 3L646.403 9.31046",
    stroke: "#D2D8DF",
    strokeWidth: 1.47406,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 33",
    d: "M625.96 19.0547L633.344 19.2493",
    stroke: "#D2D8DF",
    strokeWidth: 1.47406,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 35",
    d: "M645.064 36.873L645.176 30.5625",
    stroke: "#D2D8DF",
    strokeWidth: 1.47406,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 37",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.785 702.179C113.473 703.768 104.625 711.574 101.598 720.829C101.09 712.23 95.6298 701.422 89.6221 699.865C96.9524 697.274 104.892 687.749 107.004 679.723C106.622 688.134 114.258 700.348 118.785 702.179Z",
    fill: "#EBECEF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 39",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.197 54.6282C239.1 55.3526 231.838 60.3981 228.782 67.0293C229.146 60.5819 226.014 52.0586 221.675 50.3792C227.358 49.0818 234.098 42.674 236.364 36.8789C235.352 43.1137 239.983 52.8731 243.197 54.6282Z",
    fill: "#EBECEF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 41",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M786.31 101.446C780.835 101.327 776.496 96.7969 776.619 91.3261C776.738 85.8554 781.268 81.5163 786.735 81.6352C792.209 81.7541 796.548 86.2843 796.429 91.755C796.307 97.2257 791.78 101.565 786.31 101.446Z",
    fill: "#D1D9E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 43",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M786.341 750.703C781.58 750.603 777.803 746.656 777.904 741.895C778.005 737.131 781.952 733.354 786.716 733.455C791.48 733.56 795.257 737.502 795.153 742.267C795.048 747.027 791.105 750.808 786.341 750.703Z",
    fill: "#EBECEF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 45",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.075 232.937C67.127 232.873 64.788 230.433 64.8529 227.481C64.9141 224.533 67.3576 222.198 70.3056 222.259C73.2536 222.324 75.5925 224.764 75.5313 227.712C75.4664 230.663 73.023 233.002 70.075 232.937Z",
    stroke: "#D2D8DF",
    strokeWidth: 1.47406,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 47",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M645.19 212.274C645.19 231.248 629.805 246.63 610.834 246.63C591.855 246.63 576.478 231.248 576.478 212.274C576.478 193.299 591.855 177.914 610.834 177.914C629.805 177.914 645.19 193.299 645.19 212.274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 49",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.967 666.316L213.784 350.375C213.024 345.697 215.175 341.026 219.219 338.561L354.405 256.042C357.065 254.421 360.258 253.927 363.278 254.673L530.035 295.916C533.16 296.687 536.464 296.132 539.167 294.385L650.723 222.202C657.282 217.956 666.083 221.239 668.252 228.746L762.113 552.818C763.486 557.564 761.72 562.66 757.709 565.54L655.004 639.142C652.219 641.135 648.705 641.806 645.386 640.977L450.035 592.14C447.303 591.459 444.413 591.787 441.908 593.066L281.779 674.836C274.737 678.429 266.235 674.122 264.967 666.316Z",
    fill: "#F1F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 51",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M611.257 238.996C595.011 238.996 581.842 225.823 581.842 209.577C581.842 193.331 595.011 180.158 611.257 180.158C627.507 180.158 640.676 193.331 640.676 209.577C640.676 225.823 627.507 238.996 611.257 238.996ZM611.255 147.47C577.908 146.526 550.107 172.795 549.163 206.142C549.137 207.09 549.134 208.041 549.152 208.989C549.152 260.503 606.678 308.161 609.099 310.122C610.321 311.171 612.123 311.171 613.348 310.122C615.896 307.837 673.361 255.404 673.361 208.989C673.988 175.631 647.46 148.083 614.102 147.459C613.154 147.441 612.206 147.445 611.255 147.47Z",
    fill: "url(#paint0_linear_5788_71736)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 53",
    d: "M379.57 522.951L479.139 548.928C489.616 551.659 497.858 539.914 491.703 531.009C457.332 481.304 393.002 378.286 453.53 382.611C533.184 388.301 518.011 460.235 535.079 469.786C552.151 479.332 654.56 458.004 658.351 420.311C662.146 382.611 648.873 363.647 622.319 352.269C595.769 340.888 609.097 310.125 609.097 310.125",
    stroke: "#0E1D25",
    strokeWidth: 2.94813,
    strokeDasharray: 10.32
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 55",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.235 392.334L245.42 365.834C243.913 359.981 246.508 353.844 251.759 350.842L334.815 303.382C335.471 303.007 336.152 302.69 336.858 302.43L364.388 292.357C366.771 291.485 369.355 291.305 371.838 291.842L432.247 304.913C437.087 305.958 440.954 309.584 442.312 314.341C444.904 323.409 437.584 332.245 428.196 331.391L401.62 328.977C393.119 328.202 386.066 335.46 387.082 343.937L389.529 364.331C390.272 370.515 386.661 376.397 380.811 378.534L324.972 398.929C321.037 400.363 316.662 399.88 313.134 397.624L297.82 387.829C291.568 383.825 283.253 385.663 279.268 391.926L276.55 396.197C270.247 406.1 255.161 403.704 252.235 392.334Z",
    fill: "#D8DBEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 57",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M619.326 512.261L638.391 593.972C640.582 603.364 651.679 607.447 659.434 601.713L722.91 554.794C727.35 551.518 729.325 545.856 727.894 540.526L713.003 485.026C711.035 477.688 703.377 473.446 696.118 475.67L628.466 496.382C621.716 498.447 617.722 505.388 619.326 512.261Z",
    fill: "#D8DBEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 59",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541.001 539.314L584.54 542.103C590.241 542.471 595.088 546.406 596.613 551.917L605.075 582.485C607.799 592.32 598.984 601.474 589.052 599.121L545.956 588.914C541.646 587.894 538.114 584.81 536.525 580.676L527.619 557.521C524.109 548.388 531.238 538.69 541.001 539.314Z",
    fill: "#D8DBEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 61",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339.515 519.428C321.925 519.428 307.664 505.168 307.664 487.58C307.664 469.99 321.925 455.729 339.515 455.729C357.106 455.729 371.363 469.99 371.363 487.58C371.363 505.168 357.106 519.428 339.515 519.428ZM339.511 420.343C303.403 419.32 273.311 447.758 272.287 483.862C272.258 484.889 272.255 485.916 272.273 486.944C272.273 542.714 334.556 594.311 337.176 596.434C338.498 597.569 340.452 597.569 341.774 596.434C344.538 593.958 406.746 537.197 406.746 486.944C407.427 450.832 378.704 421.006 342.589 420.329C341.562 420.311 340.535 420.314 339.511 420.343Z",
    fill: "url(#paint1_linear_5788_71736)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5788_71736",
    x1: 549.141,
    y1: 147.445,
    x2: 549.141,
    y2: 310.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAD961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F76B1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5788_71736",
    x1: 339.51,
    y1: 331.832,
    x2: 169.002,
    y2: 461.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF62A5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakeMeThere);
export default __webpack_public_path__ + "static/media/TakeMeThere.7a67a70dde55dbd5b4c7a8700a570ae6.svg";
export { ForwardRef as ReactComponent };